import qs from 'qs';
import { APPLICANT, BACKGROUND, CREDIT } from '../constants/overviewSections';
import { URLS } from '../constants/urls';
const { SCREENING, SCREENING_BACKGROUND_CHECK, SCREENING_CREDIT_REPORT } = URLS;

export function routeFormatter(url) {
  return url.slice(-1) === '/' ? url.slice(0, -1) : url;
}

export function getPropertyId(location) {
  return qs.parse(location.search, { ignoreQueryPrefix: true }).propertyId;
}

export function getPageLocationForOverviewSection(sectionId) {
  switch (sectionId) {
    case BACKGROUND:
      return `${SCREENING}/${SCREENING_BACKGROUND_CHECK}`;
    case CREDIT:
      return `${SCREENING}/${SCREENING_CREDIT_REPORT}`;
    case APPLICANT:
    default:
      // The details page is at the root of the applicant path.
      return '';
  }
}
